export enum OrderOptimizerDetailsUpdateParamsStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

type OrderOptimizerDetailsUpdateParams = {
  id: string;
  status?: OrderOptimizerDetailsUpdateParamsStatus;
};

export default OrderOptimizerDetailsUpdateParams;
